import { Inject, Injectable } from '@angular/core';

import { MyBetsFixture } from '@cds/my-bets';
import { BatchRequest, MyBetsFixtureRequest } from '@cds/query-objects';
import { CdsConfig } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { isDefined } from '@frontend/sports/common/core/utils/extended-types';
import { BaseCdsApi, BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { chunk, merge } from 'lodash-es';
import { Observable, catchError, forkJoin, map } from 'rxjs';

export interface MyBetsBatchResponse {
    [key: string]: MyBetsFixture;
}

@Injectable({ providedIn: 'root' })
export class MyBetsOfferApi {
    private myBetsApi: BaseCdsApi;
    private readonly logger: SportsRemoteLogger;

    constructor(
        @Inject(CDS_API_FACTORY) cdsApiServiceFactory: BaseCdsApiFactory,
        private cdsConfig: CdsConfig,
        loggerFactory: LoggerFactory,
    ) {
        this.myBetsApi = cdsApiServiceFactory({ endpoint: '/my-bets-offer' });
        this.logger = loggerFactory.getLogger('MyBetsOfferApi');
    }

    getMyBetsFixtureList(request: BatchRequest<MyBetsFixtureRequest>[]): Observable<MyBetsBatchResponse | undefined> {
        const pagedRequests = chunk(request, this.cdsConfig.maxFixtureBatchSize);
        const requestObservables = pagedRequests.map((r) => this.myBetsApi.post<MyBetsBatchResponse>(`/fixtures/batch`, r));

        return forkJoin(requestObservables).pipe(
            catchError((err) => {
                this.logger.error(err, `Failed calling fixture-batch endpoint. Request: ${JSON.stringify(request)}`);

                return [];
            }),
            map((results) => merge({}, ...results.filter(isDefined))),
        );
    }
}
